import feed from './feed'

export { feed }
